import { createStore, applyMiddleware } from 'redux'
import reducer from './reducer'
// import logger from 'redux-logger'
import { IsProduction } from 'utils/constant'

const middleware = IsProduction ? applyMiddleware() : applyMiddleware()

const store = createStore(reducer, middleware)
window['store'] = store
export default store
